import { PageTitle } from '@affine/core/components/page-list';
import { assertExists } from '@blocksuite/affine/global/utils';
import type {
  DocMetaResponseOutputData,
  GetWikiDocByWorkspaceResponseOutputData,
  GetWikiDocByWorkspaceResponseOutputDataCreatedBy,
} from '@docnboard/rest';

import type { PageListItemProps, RequiredProps } from './types';

export const createAvatarProps = (
  user?: GetWikiDocByWorkspaceResponseOutputDataCreatedBy
) => {
  const displayName = user?.name ?? user?.email;
  return {
    size: 20,
    url: user?.avatarUrl,
    name: displayName,
    avatarTooltipOptions: {
      content: displayName,
      portalOptions: { container: document.body },
    },
  };
};

export function pageMetaToListItemProp(
  item: GetWikiDocByWorkspaceResponseOutputData,
  props: RequiredProps<DocMetaResponseOutputData>,
  pageIds?: string[]
): PageListItemProps {
  const toggleSelection = props.onSelectedIdsChange
    ? () => {
        assertExists(props.selectedIds);
        const prevSelected = props.selectedIds.includes(item.docId);
        if (!prevSelected) {
          props.onSelectedIdsChange?.([...props.selectedIds, item.docId]);
        } else {
          props.onSelectedIdsChange?.(
            props.selectedIds.filter(id => id !== item.docId)
          );
        }
      }
    : undefined;
  return {
    pageId: item.docId,
    status: item.syncStatus === 'Completed' ? item.status : item.syncStatus,
    updatedBy: item.updatedBy,
    createdBy: item.createdBy,
    createdAt: item.createdAt ? new Date(item.createdAt) : new Date(),
    updatedAt: item.updatedAt ? new Date(item.updatedAt) : undefined,
    pageIds,
    title: <PageTitle id={item.docId} />,
    to: `/${item.docId}`,
    onClick: toggleSelection,
    selectable: props.selectable,
    disabled: props.disabled,
    selected: props.selectedIds?.includes(item.docId),
    onSelectedChange: toggleSelection,
    selectedIds: props.selectedIds,
  };
}
